import { useI18n } from "../../i18n";
import { Badge, type BadgeProps } from "../Badge";
import styles from "./AdvantageList.module.css";

import type { JSX } from "react";

type AdvantageListProps = {
  title?: string;
  list: BadgeProps[];
};

const AdvantageList = (props: AdvantageListProps): JSX.Element => {
  const { title = "", list } = props;
  const { t } = useI18n();

  return (
    <div className={styles.advantageList}>
      {title !== "" && <h4>{t(title)}</h4>}
      {list.map((item) => {
        return <Badge label={item.label} useIcon={item.useIcon} key={item.label} />;
      })}
    </div>
  );
};

export { AdvantageList };
